import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function FinalCloseSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 bg-[#FDFBF7] relative overflow-hidden" data-id="element-72">
      <Container data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center space-y-10" data-id="element-74">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-gray-900 leading-tight md:leading-tight" data-id="element-75">
            Some problems become so routine that people stop imagining life
            without them.
            <br data-id="element-76" />
            <br data-id="element-77" />
            <span className="text-[#1E40AF] italic" data-id="element-78">
              Until one quiet night reminds you what normal used to feel like.
            </span>
          </h2>

          <div className="pt-8" data-id="element-79">
            <Button onClick={scrollToPricing} size="xl" className="shadow-xl shadow-blue-900/10" data-id="element-80">
              Get Back To Quiet Sleep Tonight
            </Button>
          </div>
        </motion.div>
      </Container>
    </section>;
}